import { defineClassNames } from '../../../utils/defineClassNames';

export const classes = defineClassNames('side-panel-divider', {});
